import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const DeliveryVehicle = () => {
  return(
    <SettingsMetaData propertyName={"DeliveryVehicle"} viewPropertyName={"Delivery Vehicle"} />
  )
};

export default DeliveryVehicle;
